import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.OpinionComparisonRoot),
  () => import('./OpinionComparison'),
  (OpinionComparison) => {
    ComponentUtil.binder(Hooks.OpinionComparisonRoot, OpinionComparison);
  },
);
